import { Theme, ThemedStyles } from 'ui/base/theme';
import { UnreachableFunction } from 'ui/base/types';

import Messages from './actions_messages';
import baseStyles from './actions.module.css';

import iconImageAllowedDaylight from './actions_icons/allowed/light.png';
import iconImageAllowedMidnight from './actions_icons/allowed/dark.png';
import iconImageBlockedDaylight from './actions_icons/blocked/light.png';
import iconImageBlockedMidnight from './actions_icons/blocked/dark.png';

export enum Action {
  ALLOWED = 'allowed',
  BLOCKED = 'blocked',
}

export const actionsSymbolsMap = new Map<Action, string>([
  [Action.ALLOWED, '\u2713\uFE0E'],
  [Action.BLOCKED, '\u2715\uFE0E'],
]);

export const castActionFromBooleanMap = new Map<boolean, Action>([
  [true, Action.ALLOWED],
  [false, Action.BLOCKED],
]);

export function fromBoolean(action: boolean) {
  return castActionFromBooleanMap.get(action) ?? null;
}

export const ORDERED_ACTIONS: readonly Action[] = [
  Action.ALLOWED,
  Action.BLOCKED,
];

export function getFullAction(action: Action|null) {
  return `${getMicroAction(action)} ${getShortAction(action)}`;
}

export function getShortAction(action: Action|null) {
  switch(action) {
    case Action.ALLOWED:
      return Messages.allowed();
    case Action.BLOCKED:
      return Messages.blocked();
    default:
      return Messages.unknown();
  }
}

export function getMicroAction(action: Action|null) {
  return (action !== null ? actionsSymbolsMap.get(action) : null) ?? '?';
}

export type ActionIconStyles = {
  allowed: string;
  blocked: string;
};

export const themedActionIconClassStyles: ThemedStyles<ActionIconStyles> = {
  [Theme.DAYLIGHT]: {
    allowed: baseStyles.daylightActionIconAllowed,
    blocked: baseStyles.daylightActionIconBlocked,
  },
  [Theme.MIDNIGHT]: {
    allowed: baseStyles.midnightActionIconAllowed,
    blocked: baseStyles.midnightActionIconBlocked,
  },
};

export const themedActionIconImageStyles: ThemedStyles<ActionIconStyles> = {
  [Theme.DAYLIGHT]: {
    allowed: iconImageAllowedDaylight,
    blocked: iconImageBlockedDaylight,
  },
  [Theme.MIDNIGHT]: {
    allowed: iconImageAllowedMidnight,
    blocked: iconImageBlockedMidnight,
  },
};

export const getActionIconClass = (styles: ActionIconStyles, action: Action): string => {
  switch(action) {
    case Action.ALLOWED:
      return styles.allowed;
    case Action.BLOCKED:
      return styles.blocked;
    default:
      return UnreachableFunction(action);
  }
};
